export default class VelhoLocationSpesificationModel {
    /**
     * Creates an instance of Velho location spesification
     @param {{
        ramps: number[],
        lanes: number[],
        shoulders: number[],
        side: number,
        edge_areas: number[],
        platforms: number[],
        dividers: number[],
        ditch_bottoms: number[],
        tracks: number[],
        center_area: number
    }} locationSpecification
     */
    constructor(
        locationSpecification = {}
    ) {
        /** @type {number[]} */
        this.ramps = locationSpecification.ramps && locationSpecification.ramps.length > 0 ? locationSpecification.ramps[0] : null
        /** @type {number[]} */
        this.lanes = locationSpecification.lanes && locationSpecification.lanes.length > 0 ? locationSpecification.lanes[0] : null
        /** @type {number[]} */
        this.shoulders = locationSpecification.shoulders && locationSpecification.shoulders.length > 0 ? locationSpecification.shoulders[0] : null
        /** @type {number} */
        this.side = locationSpecification.side ? locationSpecification.side : null
        /** @type {number[]} */
        this.edge_areas = locationSpecification.edge_areas && locationSpecification.edge_areas.length > 0 ? locationSpecification.edge_areas[0] : null
        /** @type {number[]} */
        this.platforms = locationSpecification.platforms && locationSpecification.platforms.length > 0 ? locationSpecification.platforms[0] : null
        /** @type {number[]} */
        this.dividers = locationSpecification.dividers && locationSpecification.dividers.length > 0 ? locationSpecification.dividers[0] : null
        /** @type {number[]} */
        this.ditch_bottoms = locationSpecification.ditch_bottoms && locationSpecification.ditch_bottoms.length > 0 ? locationSpecification.ditch_bottoms[0] : null
        /** @type {number[]} */
        this.tracks = locationSpecification.tracks && locationSpecification.tracks.length > 0 ? locationSpecification.tracks[0] : null
        /** @type {number} */
        this.center_area = locationSpecification.center_area ? locationSpecification.center_area : null
    }

    /**
    * Convert model to json object.
    * @returns {object}
    */
    toJSON() {
        return {
            ramps: this.ramps && !Array.isArray(this.ramps) ? [this.ramps] : this.ramps || [],
            lanes: this.lanes && !Array.isArray(this.lanes) ? [this.lanes] : this.lanes || [],
            shoulders: this.shoulders && !Array.isArray(this.shoulders) ? [this.shoulders] : this.shoulders || [],
            side: this.side,
            edge_areas: this.edge_areas && !Array.isArray(this.edge_areas) ? [this.edge_areas] : this.edge_areas || [],
            platforms: this.platforms && !Array.isArray(this.platforms) ? [this.platforms] : this.platforms || [],
            dividers: this.dividers && !Array.isArray(this.dividers) ? [this.dividers] : this.dividers || [],
            ditch_bottoms: this.ditch_bottoms && !Array.isArray(this.ditch_bottoms) ? [this.ditch_bottoms] : this.ditch_bottoms || [],
            tracks: (this.tracks != null || this.tracks != undefined) && !Array.isArray(this.tracks) ? [this.tracks] : this.tracks || [],
            center_area: this.center_area
        }
    }
}
